export const undefOrNull = (arg: any) => arg === undefined || arg == 'undefined' || arg === null;
